import React from 'react';

function SVG( props ){

  return (
    <svg viewBox='0 0 194 121'
      role='img'
      { ...props }
      aria-label='Visa Credit Card Logo'
    >
      <title>Visa Credit Card Logo</title>
      <desc>Visa Credit Card image</desc>
      <g>
        <g>
          <rect
            style={ { fill:'#3a58a8' } }
            width='194'
            height='121'
            rx='5'
            ry='5'
          />
          <polygon
            style={ { fill:'#fff' } }
            points='89.28 78.71 79.8 78.71 85.72 42.31 95.2 42.31 89.28 78.71'
          />
          <path
            style={ { fill:'#fff' } }
            d='M71.83,42.31l-9,25L61.72,62h0L58.53,45.59s-.39-3.28-4.5-3.28H39.1l-.17.62a35.37,35.37,0,0,1,9.91,4.16l8.23,31.62h9.88L82,42.31Z'
          />
          <path
            style={ { fill:'#fff' } }
            d='M146.37,78.71h8.7l-7.59-36.4h-7.62A4.36,4.36,0,0,0,135.49,45L121.36,78.71h9.88l2-5.41h12.05ZM135.94,65.84l5-13.62,2.8,13.63Z'
          />
          <path
            style={ { fill:'#fff' } }
            d='M122.1,51.06l1.35-7.82a27.36,27.36,0,0,0-8.52-1.59c-4.7,0-15.87,2.06-15.87,12.05,0,9.4,13.11,9.52,13.11,14.46s-11.76,4.06-15.64.94l-1.41,8.17a26.54,26.54,0,0,0,10.7,2.06C112.28,79.34,122,76,122,66.88c0-9.46-13.23-10.35-13.23-14.46S118,48.83,122.1,51.06Z'
          />
          <path
            style={ { fill:'#faa634' } }
            d='M61.72,62,58.53,45.59s-.39-3.28-4.5-3.28H39.1l-.17.62A36.71,36.71,0,0,1,53,50,28.4,28.4,0,0,1,61.72,62Z'
          />
        </g>
      </g>
    </svg>
  )
}

export default SVG;
